var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53332 16.0001L14.9333 21.3334L23.4667 10.6668M16 30.9334C14.0389 30.9334 12.097 30.5472 10.2852 29.7967C8.47345 29.0462 6.82721 27.9463 5.44052 26.5596C4.05383 25.1729 2.95385 23.5266 2.20338 21.7148C1.45291 19.9031 1.06665 17.9612 1.06665 16.0001C1.06665 14.039 1.45291 12.0972 2.20338 10.2854C2.95385 8.47357 4.05383 6.82733 5.44052 5.44064C6.82721 4.05396 8.47345 2.95398 10.2852 2.2035C12.097 1.45303 14.0389 1.06677 16 1.06677C19.9606 1.06677 23.7589 2.6401 26.5594 5.44065C29.36 8.24119 30.9333 12.0395 30.9333 16.0001C30.9333 19.9607 29.36 23.759 26.5594 26.5596C23.7589 29.3601 19.9606 30.9334 16 30.9334Z",
    stroke: "#50AD20",
    strokeWidth: 2.13333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectCircleIcon);
export default __webpack_public_path__ + "static/media/CorrectCircleIcon.6a86910c81a80a62f143cd8bb2a1a74b.svg";
export { ForwardRef as ReactComponent };